// src/hooks/useClubPrograms.js
import { useState, useEffect } from 'react';
import { collection, query, where, orderBy, onSnapshot } from 'firebase/firestore';
import { db } from '@/firebase/firebase';

/**
 * Live list of programs belonging to a club, newest first.
 *
 * @param {string|null} clubId
 * @returns {{ programs: Object[], loading: boolean }}
 */
export default function useClubPrograms(clubId) {
  const [programs, setPrograms] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!clubId) {
      setPrograms([]);
      setLoading(false);
      return;
    }

    setLoading(true);

    const q = query(
      collection(db, 'programs'),
      where('clubId', '==', clubId),
      orderBy('createdAt', 'desc')
    );

    const unsub = onSnapshot(
      q,
      (snap) => {
        setPrograms(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
        setLoading(false);
      },
      (err) => {
        console.error('[useClubPrograms]', err);
        setLoading(false);
      }
    );

    return unsub;
  }, [clubId]);

  return { programs, loading };
}
